// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export const environment = {
  production: false,
  baseURL: 'https://app.qa.theloops.ai/v1',
    /** Cube.js API base URL; requests to /load will show in Network tab */
  cubejsURL: 'https://app.qa.theloops.ai/cubejs-api/v1',
    /** Cube.js JWT for analytics API (from /teams/authorize) */
  appId: '2',
  envName: 'qa',
    /** Base URL for this app (Teams tab contentUrl/websiteUrl); used when building for each env */
  agentHomepageBaseUrl: 'https://agenthomepage.qa.theloops.ai',
  reactAppBaseUrl: 'https://#tenantId#.qa.theloops.ai'
};
